export default __webpack_public_path__ + "static/char-thumb-53-dc7a3813d9c0fe8ecb8d4064025af374.webp";